import React from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import { HBox, LinkWithImage, Text, IconWithLink } from './primitives.components'

const getAppStoreImage = locale =>
  require(`../../../common_assets/images/download_appstore_${locale}.svg`)

const getandroidStoreImage = locale =>
  require(`../../../common_assets/images/download_googleplay_${locale}.svg`)

export const MenuFrame = props =>
  <ReactCSSTransitionGroup
    transitionName="menu__container"
    transitionEnterTimeout={400}
    transitionLeaveTimeout={400}
  >
    {props.isMenuOpen
      ? <div
          className={`menu__container`}
          onClick={() => props.toggleMenu()}
          style={{ marginTop: `${props.topAdMargin}px` }}
        >
          <div className={`menu__container-list`} onClick={e => e.stopPropagation()}>
            {props.children}
          </div>
        </div>
      : null}
  </ReactCSSTransitionGroup>

export const MenuDownloadAppContainer = props =>
  <div className="download-apps">
    <Text className={'header'}>
      {props.downloadOurAppText}
    </Text>
    <HBox className="download-apps__items">
      <LinkWithImage
        href={props.mobile.ios_url}
        src={getAppStoreImage(props.mobile.ios_icon_locale)}
        className="store"
        data-analytics-event-category="navigation mobile"
        data-analytics-event-action="hamburger menu download app click"
        data-analytics-event-label="app store"
      />
      <LinkWithImage
        href={props.mobile.android_url}
        src={getandroidStoreImage(props.mobile.android_icon_locale)}
        className="store"
        data-analytics-event-category="navigation mobile"
        data-analytics-event-action="hamburger menu download app click"
        data-analytics-event-label="google play"
      />
    </HBox>
  </div>

export const MenuSocialContainer = props =>
  <div>
    <Text className={'header'}>
      {props.stayUpToDateText}
    </Text>
    <HBox className="social__items">
      {props.items.map(item =>
        <IconWithLink
          href={item.url}
          size="32"
          iconName={item.icon_name}
          key={item.description}
          data-analytics-event-category="navigation mobile"
          data-analytics-event-action="hamburger menu follow us click"
          data-analytics-event-label={item.description}
          className="social__item"
        />
      )}
    </HBox>
  </div>



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/menu.components.js